export default "__VITE_ASSET__LsTXWOZS__"